import ReactDOM from "react-dom/client";
import { Main } from "./app";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <Main />,
);
